<template>
  <div>
    <div class="container" v-if="!isMeeting">
      <Notes class="mt-3 mb-3"/>
    </div>
    <section class="container" :class="!isMeeting ? 'boxWithBorder' : ''">
      <SmallItinerarySidebar
        v-if="bookTrip.currentlyBooking"
        :sol="solutionAll"
        :key="
          solutionAll.flight.key + solutionAll.hotel.key + solutionAll.car.key
        "
        class="bookingDropdown mr-5"
      />

      <!-- Form Title -->
      <div
        v-if="!isMeeting"
        class="is-flex is-justify-content-center is-align-content-center mb-5"
      >
        <b-icon icon="car" size="" type="is-primary"> </b-icon>
        <h2 data-test="outsider" class="gant-text is-bold ml-1">Cars</h2>
      </div>

      <EditSearchLink
        v-if="showEditSearchLink('car')"
        :label="toggleSearchLabel('car')"
        @iconClicked="toggleSearchForm('car')"
      />

      <!-- FLIGHT DETAILS HEADER -->
      <FlightDetailsHeader />

      <div
        class="carForm"
        :class="bookTrip.currentlyBooking ? 'pt-1' : ''"
        v-if="!this.bookTravel.formsCollapsed.car"
      >
        <!-- Meeting Info Bar bar -->
        <div v-if="pathMixin_isMeeting" class="box">
          <p class="is-size-5">
            Will you provide your own transportation during this meeting?
          </p>
          <!-- <b-button>
            Opt out of flight search steps
          </b-button> -->
          <p class="is-size-6 mb-3">
            If you do not need a rental car booked for this meeting, please click
            below to skip the car search steps.
          </p>
          <b-button @click="optOutCar" type="is-primary">
            No Rental Car Required
          </b-button>
        </div>

        <div :class="pathMixin_isMeeting ? 'box' : ''">
          <div
            class="is-flex is-justify-content-space-between mt-3 flexContainer"
          >
            <div class="is-flex-grow-2 flexContainerItem">
              <b-field>
                <div class="columns is-gapless is-mobile mr-1">
                  <div class="column is-narrow">
                    <b-button
                      data-test="airport_toggle_button"
                      :type="airportSearch ? 'is-primary' : 'is-grey'"
                      icon-right="airplane"
                      @click="iconToggle(true)"
                    />
                  </div>
                  <div class="column is-narrow">
                    <b-button
                      data-test="geo_toggle_button"
                      :type="!airportSearch ? 'is-primary' : 'is-grey'"
                      icon-right="map-marker"
                      @click="iconToggle(false)"
                    />
                  </div>
                  <div class="column ml-1">
                    <div v-if="airportSearch">
                      <div class="field noBgdInput specialBgdInput">
                        <EDLocationSearch
                          icon="airplane"
                          :value="pickupLocation"
                          @locUpdate="updatePickupLocation"
                          @editting="edit1 = true"
                          includeAirports
                          v-bind:includeCities="false"
                          data-test="pickup_airport_input"
                          data-test-attr="from-destination"
                        />
                      </div>
                    </div>
                    <div v-else>
                      <div class="field noBgdInput specialBgdInput">
                        <PlaceSearch
                          theme="Pick up"
                          icon="car"
                          v-model.lazy="pickupLocation"
                          @locUpdate="updatePickupLocation"
                          @editting="edit1 = true"
                          data-test="pickup_location_input"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </b-field>
              <b-field
                v-show="diffDropLoc"
                :label="airportSearch2 ? 'Airport Drop off' : 'Location Drop off'"
              >
                <div class="columns is-gapless is-mobile mr-1">
                  <div class="column is-narrow">
                    <b-button
                      data-test="airport_toggle_button_2"
                      :type="airportSearch2 ? 'is-primary' : 'is-grey'"
                      icon-right="airplane"
                      @click="iconToggle(true, 2)"
                    />
                  </div>
                  <div class="column is-narrow">
                    <b-button
                      data-test="geo_toggle_button_2"
                      :type="!airportSearch2 ? 'is-primary' : 'is-grey'"
                      icon-right="map-marker"
                      @click="iconToggle(false, 2)"
                    />
                  </div>
                  <div class="column ml-1">
                    <div v-if="airportSearch2">
                      <div class="field">
                        <EDLocationSearch
                        data-test="dropoff_airport_input"
                          theme=""
                          icon="airplane"
                          v-model.lazy="dropoffLocation"
                          @locUpdate="updateDropoffLocation"
                          @editting="
                            edit2 = true;
                            locBool = true;
                          "
                          includeAirports
                          v-bind:includeCities="false"
                          :offerHomeAirport="false"
                          data-test-attr="to-destination"
                        />
                      </div>
                    </div>
                    <div v-else>
                      <div class="field">
                        <PlaceSearch
                        data-test="dropoff_location_input"
                          theme="Drop off"
                          icon="car"
                          v-model.lazy="dropoffLocation"
                          @locUpdate="updateDropoffLocation"
                          @editting="
                            edit2 = true;
                            locBool = true;
                          "
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </b-field>
              <b-switch
                :rounded="true"
                :value="diffDropLoc"
                @input="differentDropLoc"
                size="is-small"
                data-test="dropoff_toggle_switch"
              >
                Different Dropoff Location
              </b-switch>
            </div>
            <div class="is-flex-grow-1 flexContainerItem">
              <div
                class="mr-1 is-flex is-align-content-center is-justify-content-space-between noBgdInput specialBgdInput"
              >
                <DateSelector
                  data-test="pickup_date_selector"
                  ref="pickupDate"
                  v-model="pickupDate"
                  v-if="!pathMixin_isMeeting"
                  :placeholder="'Pick Up Date'"
                  segmentType="car"
                  :dateIndex="0"
                  :minDate="minDate"
                  :maxDate="maxDate"
                  :focusedDate="focusedDate"
                  icon="calendar"
                  style="width: 48%;"
                  @setDateRange="setDateRange"
                />
                <DateSelectorMeetings
                  v-else
                  data-test="pickup_date_selector"
                  :minDate="meetingInfo.meeting.earliestArrival.date"
                  :maxDate="meetingInfo.meeting.latestDeparture.date"
                  v-model="pickupDate"
                  
                />
                <div class="vl"></div>
                <b-select
                  placeholder="Time"
                  :value="pickupTime"
                  @input="setPickupTime"
                  icon="clock"
                  style="width: 48%;"
                >
                  <option disabled value="">Please select a time</option>
                  <option
                    v-for="option in timeOptions"
                    :value="option.value"
                    :key="option.value"
                  >
                    {{ option.label }}
                  </option>
                </b-select>
              </div>
            </div>
            <div class="is-flex-grow-1 flexContainerItem">
              <div
                class="mr-1 is-flex is-justify-content-space-between noBgdInput specialBgdInput"
              >
                <DateSelector
                  data-test="dropoff_date_selector"
                  v-model="dropoffDate"
                  v-if="!pathMixin_isMeeting"
                  :placeholder="'Drop Off Date'"
                  segmentType="car"
                  :dateIndex="1"
                  :minDate="minDate"
                  :maxDate="maxDate"
                  :focusedDate="focusedDate"
                  icon="calendar"
                  style="width: 48%;"
                  @setDateRange="setDateRange"
                />
                <DateSelectorMeetings
                  v-else
                  data-test="dropoff_date_selector"
                  :minDate="meetingInfo.meeting.earliestArrival.date"
                  :maxDate="meetingInfo.meeting.latestDeparture.date"
                  v-model="dropoffDate"
                />
                <div class="vl"></div>
                <b-select
                  placeholder="Time"
                  :value="dropoffTime"
                  @input="setDropoffTime"
                  icon="clock"
                  style="width: 48%;"
                >
                  <option disabled value="">Please select a time</option>

                  <option
                    v-for="option in timeOptions"
                    :value="option.value"
                    :key="option.value"
                  >
                    {{ option.label }}
                  </option>
                </b-select>
              </div>
            </div>
            <div class="is-flex-grow-0 flexContainerItem is-hidden-mobile">
              <b-button
                expanded
                data-test="search_button_desktop"
                @click="checkInputs"
                class="button is-primary ubuntu"
                
              >
                Search Cars
              </b-button>
            </div>
          </div>
          <b-collapse
            :open="false"
            @open="toggleAdvancedSearch(true)"
            @close="toggleAdvancedSearch(false)"
            aria-id="contentIdForA11y1"
            class="mt-3"
          >
            <AdvancedSearchOptionsLink slot="trigger" />
            <div class="notification" :style="advancedScroll">
              <div class="content">
                <div class="field">
                  <b-checkbox type="is-primary" v-model="usedAdvanced">
                    Use Advanced Settings
                  </b-checkbox>
                </div>
                <h3 v-if="!modal">
                  Extra Preferences
                </h3>
                <div>
                  <b-field label="Search by Rental Chain">
                    <TagAutocomplete
                      placeholder="e.g. Hertz"
                      icon="magnify"
                      :chainData="chainData"
                      :selected="chain"
                      @list="
                        (option) => {
                          chain = option;
                          setCarAdvanced();
                        }
                      "
                    >
                    </TagAutocomplete>
                  </b-field>
                </div>
              </div>
            </div>
          </b-collapse>
          <div class="mt-2 is-hidden-tablet">
            <b-button
              expanded
              @click="checkInputs"
              class="button is-primary ubuntu"
              data-test="search_button_mobile"
            >
              Search Cars
            </b-button>
          </div>
        </div>
      </div>

      <div v-if="validating">
        <div v-for="(result, index) in skelItems" :key="index">
          <ResultSkele />
        </div>
      </div>
      <CarResults v-if="showCarResults" :formData="formData" />
    </section>
  </div>
</template>

<script>
import DateSelector from "../../DateComponents/DateSelector.vue";
import DateSelectorMeetings from "../../DateComponents/DateSelectorMeetings";
import EDLocationSearch from "../../EDLocation/EDLocationSearch.vue";
import PlaceSearch from "../PlaceSearch.vue";
import TagAutocomplete from "../../Tags/TagAutocomplete.vue";
import TravellerModal from "../../Traveller/TravellerModal.vue";
import AdvancedSearchOptionsLink from "../../UI/AdvancedSearchOptionsLink";
import CarResults from "./CarResults";
import bookingMixin from "../../../mixins/bookingMixin";
import meetingsMixin from "../../../mixins/meetingsMixin";
import EditSearchLink from "../EditSearchLink";
import SmallItinerarySidebar from "../../Itinerary/SmallItinerarySidebar";
import app from "@/plugins/app";
import ResultSkele from "../../SkeletonLoaders/ResultSkele.vue";
import FlightDetailsHeader from "@/components/BookTravel/FlightDetailsHeader.vue";
import Notes from "../../UI/Notes.vue";

let moment = require("moment");

export default {
  name: "CarForm",
  mixins: [bookingMixin, meetingsMixin],
  components: {
    DateSelector,
    PlaceSearch,
    EDLocationSearch,
    TagAutocomplete,
    AdvancedSearchOptionsLink,
    CarResults,
    DateSelectorMeetings,
    EditSearchLink,
    SmallItinerarySidebar,
    ResultSkele,
    FlightDetailsHeader,
    Notes,
  },
  data: function() {
    return {
      times: [
        { mil: 0, format: "Midnight" },
        { mil: 1, format: "1:00 am" },
        { mil: 2, format: "2:00 am" },
        { mil: 3, format: "3:00 am" },
        { mil: 4, format: "4:00 am" },
        { mil: 5, format: "5:00 am" },
        { mil: 6, format: "6:00 am" },
        { mil: 7, format: "7:00 am" },
        { mil: 8, format: "8:00 am" },
        { mil: 9, format: "9:00 am" },
        { mil: 10, format: "10:00 am" },
        { mil: 11, format: "11:00 am" },
        { mil: 12, format: "Noon" },
        { mil: 13, format: "1:00 pm" },
        { mil: 14, format: "2:00 pm" },
        { mil: 15, format: "3:00 pm" },
        { mil: 16, format: "4:00 pm" },
        { mil: 17, format: "5:00 pm" },
        { mil: 18, format: "6:00 pm" },
        { mil: 19, format: "7:00 pm" },
        { mil: 20, format: "8:00 pm" },
        { mil: 21, format: "9:00 pm" },
        { mil: 22, format: "10:00 pm" },
        { mil: 23, format: "11:00 pm" },
      ],
      timeOptions: [
        { value: "00:00", label: "12:00 midnight" },
        { value: "00:30", label: "12:30 am" },
        { value: "01:00", label: "1:00 am" },
        { value: "01:30", label: "1:30 am" },
        { value: "02:00", label: "2:00 am" },
        { value: "02:30", label: "2:30 am" },
        { value: "03:00", label: "3:00 am" },
        { value: "03:30", label: "3:30 am" },
        { value: "04:00", label: "4:00 am" },
        { value: "04:30", label: "4:30 am" },
        { value: "05:00", label: "5:00 am" },
        { value: "05:30", label: "5:30 am" },
        { value: "06:00", label: "6:00 am" },
        { value: "06:30", label: "6:30 am" },
        { value: "07:00", label: "7:00 am" },
        { value: "07:30", label: "7:30 am" },
        { value: "08:00", label: "8:00 am" },
        { value: "08:30", label: "8:30 am" },
        { value: "09:00", label: "9:00 am" },
        { value: "09:30", label: "9:30 am" },
        { value: "10:00", label: "10:00 am" },
        { value: "10:30", label: "10:30 am" },
        { value: "11:00", label: "11:00 am" },
        { value: "11:30", label: "11:30 am" },
        { value: "12:00", label: "12:00 noon" },
        { value: "12:30", label: "12:30 pm" },
        { value: "13:00", label: "1:00 pm" },
        { value: "13:30", label: "1:30 pm" },
        { value: "14:00", label: "2:00 pm" },
        { value: "14:30", label: "2:30 pm" },
        { value: "15:00", label: "3:00 pm" },
        { value: "15:30", label: "3:30 pm" },
        { value: "16:00", label: "4:00 pm" },
        { value: "16:30", label: "4:30 pm" },
        { value: "17:00", label: "5:00 pm" },
        { value: "17:30", label: "5:30 pm" },
        { value: "18:00", label: "6:00 pm" },
        { value: "18:30", label: "6:30 pm" },
        { value: "19:00", label: "7:00 pm" },
        { value: "19:30", label: "7:30 pm" },
        { value: "20:00", label: "8:00 pm" },
        { value: "20:30", label: "8:30 pm" },
        { value: "21:00", label: "9:00 pm" },
        { value: "21:30", label: "9:30 pm" },
        { value: "22:00", label: "10:00 pm" },
        { value: "22:30", label: "10:30 pm" },
        { value: "23:00", label: "11:00 pm" },
        { value: "23:30", label: "11:30 pm" },
      ],
      pickupLocation: "",
      dropoffLocation: "",
      pickupDate: null,
      dropoffDate: null,
      pickupTime: "12:00",
      dropoffTime: "12:00",
      chain: [],
      formData: {},
      diffDropLoc: false,
      usedAdvanced: false,
      date: new Date(),
      locBool: false,
      edit1: false,
      edit2: false,
      airportSearch: true,
      airportSearch2: true,
      carName: "",
      carSelected: null,

      //meetingsPickup: null,
      //meetingsDropoff: null,
      //meetingDatePU: null,
      //meetingDateDO: null,
      skelItems: [{}, {}, {}, {}],
      validating: false,
    };
  },
  props: {
    modal: Boolean,
    active: Boolean,
  },
  computed: {
    showCarResults() {
      return Object.keys(this.formData).length > 0;
    },
    chainData() {
      return Object.entries(this.$store.state.bookTravel.vendors.carProviders);
    },
    advancedScroll() {
      if (this.modal) {
        return "overflow:scroll; height:200px;";
      } else {
        return "";
      }
    },
    buttonDisable() {
      return false;
    },
    filteredDataArray() {
      return this.chainData.filter((option) => {
        return (
          option
            .toString()
            .toLowerCase()
            .indexOf(this.carName.toLowerCase()) >= 0
        );
      });
    },
    meetingStartDateCal() {
      var date = new Date(this.meetingInfo.meeting.meetingStartDate);
      date = date.addDays(2);
      date = moment(date).format("YYYY-MM-DD");
      return date;
    },
    focusedDate() {
      if (this.pickupDate) {
        return this.pickupDate;
      } else {
        return new Date();
      }
    },
    minDate() {
      if (this.pathMixin_isMeeting) {
        return this.minMeetingDepartDate;
      } else {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return today;
      }
    },
    maxDate() {
      if (this.pathMixin_isMeeting) {
        return this.maxMeetingReturnDate;
      } else {
        return this.$date.getLastTravelDate().toDate();
      }
    },

    //rounded down to nearest half hour
    flightArrivalTimeRounded() {
      if (this.flightArrivalMoment.minutes() >= 30) {
        return this.flightArrivalMoment
          ?.minutes(30)
          .seconds(0)
          .milliseconds(0)
          .format("HH:mm");
      } else {
        return this.flightArrivalMoment
          ?.minutes(0)
          .seconds(0)
          .milliseconds(0)
          .format("HH:mm");
      }
    },

    //rounded up to nearest half hour
    flightDepartureTimeRounded() {
      if (this.flightDepartureMoment.minutes() >= 30) {
        return this.flightDepartureMoment
          ?.add(30, "m")
          .minutes(0)
          .seconds(0)
          .milliseconds(0)
          .format("HH:mm");
      } else {
        return this.flightDepartureMoment
          ?.add(30, "m")
          .minutes(30)
          .seconds(0)
          .milliseconds(0)
          .format("HH:mm");
      }
    },

    errorMessages() {
      var messages = [];
      var firstTravelDate = this.$date.getFirstTravelDate();
      var puDate = this.pickupDate;
      var doDate = this.dropoffDate;
      //puDate.setHours(this.pickupTime);
      //doDate.setHours(this.dropoffTime);

      let loc1 = this.$helpers.findAirportByCode(this.pickupLocation.code);
      let loc2 = this.$helpers.findAirportByCode(this.dropoffLocation.code);

      if (
        (loc1.length === 0 && this.airportSearch) ||
        (this.pickupLocation.name == "" && !this.airportSearch)
      ) {
        messages.push("Please enter a valid pickup location");
      }

      if (
        ((loc2.length === 0 && this.airportSearch2) ||
          (this.dropoffLocation.name == "" && !this.airportSearch2)) &&
        this.diffDropLoc
      ) {
        messages.push("Please enter a valid dropoff location");
      }

      // Validate Dates
      
        if (puDate < firstTravelDate) {
          messages.push("Please select a future pick-up date");
        }
        if (doDate < firstTravelDate) {
          messages.push("Please select a future return date");
        } else if (doDate <= puDate) {
          messages.push("Drop-off date must be after the pick-up date");
        }
      

      return messages;
    },
  },
  methods: {
    differentDropLoc(val) {
      //var settings = this.carDetailsAlt.advancedSettings;
      //settings.diffDropLoc = val;
      //this.$store.commit("bookTravel/ALTER_C_ADVANCED", settings);
      this.diffDropLoc = val;
    },
    toggleAdvancedSearch(val) {
      this.usedAdvanced = val;
    },
    setCarAdvanced() {
      //let settings = this.carDetailsAlt.advancedSettings;
      //settings.active = this.usedAdvanced;
      //this.$store.commit("bookTravel/ALTER_C_ADVANCED", settings);
    },

    updatePickupLocation(value) {
      this.pickupLocation = value;

      //Pre-fill PickupDate field
      if (this.pickupDate == null) {
        this.setPickupDate(new Date());
      }
      //this.togglePickupDate();
      
    },
    updateDropoffLocation(value) {
      this.dropoffLocation = value;
    },
    togglePickupDate() {
      this.$refs.pickupDate.toggle();
    },
    setPickupDate(value) {
      this.pickupDate = value;
    },
    setDropoffDate(value) {
      this.dropoffDate = value;
    },
    setDropoffTime(value) {
      this.dropoffTime = value;
      this.edit2 = false;
    },
    setPickupTime(value) {
      this.pickupTime = value;
      this.edit2 = false;
    },
    setDateRange(range) {
      this.pickupDate = range[0];
      this.dropoffDate = range[1];
    },
    iconToggle(val, num = 1) {
      //let settings = this.carDetailsAlt.advancedSettings;
      if (num == 2) {
        //settings.airportSearch2 = val;
        this.airportSearch2 = val;
      } else {
        //settings.airportSearch = val;
        this.airportSearch = val;
      }
    },
    cardModal(closable = true) {
      var details = {
        parent: this,
        component: TravellerModal,
        props: {
          profiler: this.$globals.profile,
          closable: closable,
        },
        hasModalCard: true,
        trapFocus: false,
        width: 700,
      };
      this.$buefy.modal.open(details);
    },
    logSearchEvent() {

      // Log the event
      let eventData = {
        event_type: 'Search Submitted',
        event_properties: {
          item_type: 'car',
          // days_until_travel:
          is_meeting_mode: this.pathMixin_isMeeting,
        }
      }
        
      this.$app.logEvent(eventData);
    },
    checkInputs() {
      if (this.errorMessages.length > 0) {
        this.launchInputErrorDialog(this.errorMessages);
      } else {
        this.search();
      }
    },
    search() {
      if (this.$store.state.travellersAndTrips.travellers.set) {
        this.sendSearch();
      } else {
        this.cardModal();
      }
    },
    sendSearch() {
      this.switchMapView("car", false);
      this.setCarAdvanced();

      this.logSearchEvent();

      //setting or updating the values of the formData object here triggers the formData watcher in CarResults.vue,
      //which then calls the CarResults getData() method to submit the search to HuddleLabs API
      this.formData = {
        pickupLocation: this.pickupLocation,
        dropoffLocation: this.dropoffLocation,
        pickupDate: this.pickupDate,
        dropoffDate: this.dropoffDate,
        pickupTime: this.pickupTime,
        dropoffTime: this.dropoffTime,
        advancedSettings: {
          active: this.usedAdvanced,
          chain: this.chain,
          diffDropLoc: this.diffDropLoc,
          airportSearch: this.airportSearch,
          airportSearch2: this.airportSearch2,
        },
      };

      /*
      let queries = {};
      queries.usedAdvanced = this.usedAdvanced;
      queries.puTime = this.pickupTime;
      queries.doTime = this.dropoffTime;
      queries.startDate = moment(this.pickupDate).format("YYYY-MM-DD");
      queries.endDate = moment(this.dropoffDate).format("YYYY-MM-DD");

      if (this.pathMixin_isMeeting) {
        queries.startDate = moment(this.meetingDatePU).format("YYYY-MM-DD");
        queries.endDate = moment(this.meetingDateDO).format("YYYY-MM-DD");
      }

      if (!this.airportSearch) {
        // console.log('not airport search');
        if (this.carDetailsAlt.loc1.geometry) {
          queries.lat1 = this.carDetailsAlt.loc1.geometry.location.lat;
          queries.lng1 = this.carDetailsAlt.loc1.geometry.location.lng;
        }
        if (this.carDetailsAlt.loc1.geocode) {
          queries.lat1 = this.carDetailsAlt.loc1.geocode.latitude;
          queries.lng1 = this.carDetailsAlt.loc1.geocode.longitude;
        }
        if (this.carDetailsAlt.loc1.lat) {
          queries.lat1 = this.carDetailsAlt.loc1.lat;
          queries.lng1 = this.carDetailsAlt.loc1.lng;
        }
      } else {
        // console.log('airport search');
        queries.iata1 = this.carDetailsAlt.loc1.iataCode;
      }

      if (this.diffDropLoc) {
        if (!this.airportSearch2) {
          if (this.carDetailsAlt.loc2.geometry) {
            queries.lat2 = this.carDetailsAlt.loc2.geometry.location.lat;
            queries.lng2 = this.carDetailsAlt.loc2.geometry.location.lng;
          }
          if (this.carDetailsAlt.loc2.geocode) {
            queries.lat2 = this.carDetailsAlt.loc2.geocode.latitude;
            queries.lng2 = this.carDetailsAlt.loc2.geocode.longitude;
          }
          if (this.carDetailsAlt.loc2.lat) {
            queries.lat2 = this.carDetailsAlt.loc2.lat;
            queries.lng2 = this.carDetailsAlt.loc2.lng;
          }
        } else {
          queries.iata2 = this.carDetailsAlt.loc2.iataCode;
        }
      }

      // console.log('car queries:', queries);
      this.formData = queries;
      */
    },
    setDefaultFormValues() {
      //Use booked flight details to set default form values
      if (this.flightArrivalMoment.isValid()) {
        this.pickupDate = this.flightArrivalDate;
        this.pickupTime = this.flightArrivalTimeRounded;
      }

      if (this.flightDepartureMoment.isValid()) {
        this.dropoffDate = this.flightDepartureDate;
        this.dropoffTime = this.flightDepartureTimeRounded;
      }

      if (this.flightArrivalLeg?.arrivingAirport) {
        this.pickupLocation = this.$helpers.findAirportByCode(
          this.flightArrivalLeg.arrivingAirport
        );
      }
    },

    setSearchDataFromStore() {
      // Check if there's car search data from HomeV2
      const carSearchData = this.$store.state.bookTravel.carSearchData;
      if (carSearchData) {
        // Populate form with search data
        this.pickupLocation = carSearchData.pickupLocation;
        this.dropoffLocation = carSearchData.dropoffLocation;
        this.pickupDate = carSearchData.pickupDate;
        this.dropoffDate = carSearchData.dropoffDate;
        this.pickupTime = carSearchData.pickupTime;
        this.dropoffTime = carSearchData.dropoffTime;
        this.diffDropLoc = carSearchData.differentDropoff;
        this.airportSearch = carSearchData.airportSearch;
        this.airportSearch2 = carSearchData.airportSearchDropoff;

        // Set rental company if provided
        if (carSearchData.rentalCompany) {
          // Find the rental company in the chain data
          const chainEntry = this.chainData.find(([key, value]) =>
            key.toLowerCase() === carSearchData.rentalCompany.toLowerCase() ||
            value.toLowerCase().includes(carSearchData.rentalCompany.toLowerCase())
          );
          if (chainEntry) {
            this.chain = [chainEntry];
            this.usedAdvanced = true;
          }
        }

        // Clear the search data from store after using it
        this.$store.commit('bookTravel/CLEAR_CAR_SEARCH_DATA');

        // Trigger search automatically
        this.$nextTick(() => {
          this.search();
        });
      }
    },
  },
  mounted() {
    this.setDefaultFormValues();
    this.setSearchDataFromStore();

    // Log the event only if not coming from HomeV2 (to prevent duplicates)
    if (!this.$route.query.fromHome) {
      this.$app.logEvent({
        event_type: 'Search Started',
        event_properties: {
          item_type: 'car',
          is_meeting_mode: this.pathMixin_isMeeting,
        }
      });
    }
    //this.appendCustomHeader("car");
  },
};
</script>

<style scoped>

</style>
